import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./BlogsList.css";

const BlogsList = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await axios.get("http://localhost:8080/api/blogs");
                setBlogs(res.data);
            } catch (err) {
                setError("Failed to load blogs.");
            } finally {
                setLoading(false);
            }
        };
        fetchBlogs();
    }, []);

    if (loading)
        return <div className="blogs-message">Loading blogs...</div>;
    if (error)
        return <div className="blogs-message error">{error}</div>;

    return (
        <div className="blogs-container">
            <h1 className="blogs-title">Latest Blogs</h1>
            {blogs.length === 0 ? (
                <p className="blogs-empty">No blogs available yet.</p>
            ) : (
                <div className="blogs-grid">
                    {blogs.map((blog) => (
                        <div key={blog._id} className="blogs-card">
                            <div>
                                <h2 className="blogs-card-title">{blog.title}</h2>
                                <p className="blogs-card-intro">
                                    {blog.intro?.substring(0, 120)}...
                                </p>
                            </div>
                            <div className="blogs-card-footer">
                                <span className="blogs-card-date">
                                  {new Date(blog.createdAt).toLocaleDateString()}
                                </span>
                                <Link
                                    to={`/dashboard/blog/${blog._id}`}
                                    className="blogs-card-link"
                                >
                                    Read More →
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BlogsList;
